import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";

// GET =>  GET SERVICES
export const getServicesService = createAsyncThunk(
  "services/getServicesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.servicesURL, {
        params: { ...params },
      });
      console.log(response);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE Service SERVICE
export const createServiceService = createAsyncThunk(
  "services/createServiceService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.servicesURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE SERVICE SERVICE
export const deleteServiceService = createAsyncThunk(
  "services/deleteServiceService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.servicesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE SERVICE SERVICE
export const updateServiceService = createAsyncThunk(
  "services/updateServiceService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.servicesURL}/${params?.id}`,
        params?.data,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET => GET  SERVICE BY ID
export const getServiceByIdService = createAsyncThunk(
  "services/getServiceByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.servicesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
